import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=5adff864&scoped=true&"
import script from "./RatingStar.vue?vue&type=script&lang=js&"
export * from "./RatingStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adff864",
  null
  
)

component.options.__file = "RatingStar.vue"
export default component.exports